import { useDisclosure } from "@chakra-ui/react";
import { useEffect } from "react";

const searchPagePath = "/search/";
const scrollThreshold = 50;

const useSearchBar = () => {
  const {
    isOpen: isShowSearch,
    onToggle: toggleSearchBar,
    onClose: closeSearchBar,
  } = useDisclosure();

  const handleSearchBar = () => {
    if (window.location.pathname !== searchPagePath) {
      toggleSearchBar();
    }
  };

  const handleScroll = () => {
    const newScrollPosition = window.scrollY;
    const searchInput = document.querySelector("#searchInput");
    if (
      isShowSearch &&
      newScrollPosition > scrollThreshold &&
      (!searchInput || !searchInput.value)
    ) {
      closeSearchBar();
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isShowSearch]);

  return { isShowSearch, handleSearchBar };
};

export default useSearchBar;
